<script setup lang="ts">
  import { Button } from '@/components/ui/button'
  import { useAppStore } from '@/stores/app'
  import { useLocale } from '@/composables/useLocale'
  import { Icon } from '@iconify/vue'
  import TranslateIcon from '@/assets/svg/iconsax-translate.svg'
  import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'

  const store = useAppStore()
  const { currentLocale, toggleLocale } = useLocale()
  const { t } = useI18n()

  const themeToggleAriaLabel = computed(() =>
    store.isDark ? 'Switch to light mode' : 'Switch to dark mode'
  )
  const nextLocaleLabel = computed(() =>
    currentLocale.value === 'ar' ? t('language.en') : t('language.ar')
  )
</script>

<template>
  <Button variant="ghost" @click="toggleLocale">
    <img :src="TranslateIcon" alt="" class="size-5 me-2 dark:invert" />
    <div class="flex flex-col items-end">
      <span class="text-sm">{{ t('language.label') }}</span>
      <span class="text-xs text-muted-foreground">{{ nextLocaleLabel }}</span>
    </div>
  </Button>
  <Button
    variant="secondary"
    class="bg-brand-secondary/70 dark:bg-brand-secondary/15"
    size="icon"
    :aria-label="themeToggleAriaLabel"
    :title="themeToggleAriaLabel"
    @click="(e: MouseEvent) => store.toggleTheme(e)"
  >
    <Icon :icon="store.isDark ? 'lucide:sun' : 'lucide:moon'" class="size-5" />
  </Button>
</template>
